import { Link } from "react-router-dom";
import { LI, SVG, UL } from "../../../../AbstractElements";
import { userProfilesData } from "../../../../Data/Layout/HeaderData";
import { useLogout } from "../../../../Pages/Authentication/useAuth";

const UserProfileIcons = () => {

const logoutMutation =useLogout()

const handleClick = (name: string) => {
  if (name === "Log Out") {
    logoutMutation.mutate(); // ✅ This executes the logout function
  }
};

  return (
    <UL>
      {userProfilesData.map((item, i) => (
        <LI className="d-flex" key={i}>
          <SVG className="svg-color" iconId={item.icon} />
          <Link className="ms-2" to={item.link} onClick={() => handleClick(item.title)} >
            {item.title}
          </Link>
        </LI>
      ))}
    </UL>
  );
};

export default UserProfileIcons;
